export default __webpack_public_path__ + "static/media/IRON-3USD.652efe1a.png";